import contains from 'dom-helpers/query/contains';
import closest from 'dom-helpers/query/closest';
import events from 'dom-helpers/events';

function addEventListener(type, handler, target = document) {
  // @ts-ignore
  events.on(target, type, handler, {
    passive: false
  });
  return {
    remove() {
      // @ts-ignore
      events.off(target, type, handler);
    }
  };
}
function isOverContainer(container, x, y) {
  return !container || contains(container, document.elementFromPoint(x, y));
}
function getEventNodeFromPoint(node, {
  clientX,
  clientY
}) {
  const target = document.elementFromPoint(clientX, clientY);
  return closest(target, '#event', node);
}
function isEvent(node, bounds) {
  return !!getEventNodeFromPoint(node, bounds);
}
function getEventCoordinates(e) {
  let target = e;
  if (e.touches && e.touches.length) {
    // eslint-disable-next-line prefer-destructuring
    target = e.touches[0];
  }
  return {
    clientX: target.clientX,
    clientY: target.clientY,
    pageX: target.pageX,
    pageY: target.pageY
  };
}
function normalizeDistance(distance = 0) {
  if (typeof distance !== 'object') {
    return {
      top: distance,
      left: distance,
      right: distance,
      bottom: distance
    };
  }
  return distance;
}
function isObjectsColliding(nodeA, nodeB, tolerance = 0) {
  const {
    top: aTop,
    left: aLeft,
    right: aRight = aLeft,
    bottom: aBottom = aTop
  } = getBoundsForNode(nodeA);
  const {
    top: bTop,
    left: bLeft,
    right: bRight = bLeft,
    bottom: bBottom = bTop
  } = getBoundsForNode(nodeB);
  return !(aBottom - tolerance < bTop || aTop + tolerance > bBottom || aRight - tolerance < bLeft || aLeft + tolerance > bRight);
}
function getBoundsForNode(node) {
  if (!node.getBoundingClientRect) {
    // @ts-ignore
    return node;
  }
  const rect = node.getBoundingClientRect();
  const left = rect.left + pageOffset('left');
  const top = rect.top + pageOffset('top');
  return {
    top,
    left,
    right: (node.offsetWidth || 0) + left,
    bottom: (node.offsetHeight || 0) + top
  };
}
function pageOffset(direction) {
  if (direction === 'left') {
    return window.pageXOffset || document.body.scrollLeft || 0;
  }
  if (direction === 'top') {
    return window.pageYOffset || document.body.scrollTop || 0;
  }
  return 0;
}

export { addEventListener, getBoundsForNode, getEventCoordinates, getEventNodeFromPoint, isEvent, isObjectsColliding, isOverContainer, normalizeDistance };
